import React from "react";

import { Text, View, ScrollView, Platform, StyleSheet } from "react-native";

import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";
import CustomizeIcons from "../../common/icons/customize";
import ManaButton from "../../common/ManaButton";

export default function Intro({ onContinue }) {
  return (
    <>
      <ScrollView
        contentContainerStyle={appStyles.scrollViewContent}
        style={appStyles.scrollView}
      >
        <Text style={styles.title}>These are Elements!</Text>
        <Text style={styles.subTitle}>
          Elements represent everything you do.
        </Text>

        <View
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CustomizeIcons.WorkExampleIcon style={styles.image} />
        </View>

        <Text style={styles.bottomText}>
          To spend time better, think through what Elements make up your day
        </Text>

        <View style={styles.row}>
          <CustomizeIcons.AddIconGradient style={styles.icon} />
          <Text style={styles.linkText}>
            Add Elements to track more precisely
          </Text>
        </View>

        <View style={[styles.row, { marginTop: 16 }]}>
          <CustomizeIcons.EditPencil
            style={styles.icon}
            width={30}
            height={30}
          />
          <Text style={styles.linkText}>
            Customize Elements anytime via longpress
          </Text>
        </View>
      </ScrollView>
      <View style={appStyles.footerButtons}>
        <ManaButton
          isMainButton
          text={"Continue"}
          style={appStyles.bottomButton}
          styleText={appStyles.bottomButtonText}
          onPress={onContinue}
        />
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 26,
  },
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  subTitle: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  image: {
    marginVertical: 16,
  },
  bottomText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
    textAlign: "center",
    marginBottom: 30,
  },
  linkText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    marginLeft: 8,
  },
  icon: {
    width: 30,
    height: 30,
  },
});
